// in case of error load of prajna.js
// const prajnaDefault = {
//   use: () => {},
//   set: () => {},
//   pageView: () => {},
//   report: () => {},
//   moduleClick: () => {},
//   moduleView: () => {},
//   moduleEdit: () => {},
// };
// const prajna = window.Prajna || prajnaDefault;
//
// prajna.set({
//   pageId: 'cloud-download-page',
//   ignore: {
//     resource: [],
//     ajax: [],
//   },
// });

// const LXAnalytics = window.LXAnalytics;

const record = {
  /**
   * 手动发送 PV 事件
   * @param options
   */
  sendPV(options) { // eslint-disable-line
    // const { pageId, ...otherProps } = options;

    // LXAnalytics('pageView', { custom: otherProps }, null, pageId);

    // prajna.set({
    //   pageId,
    // });

    // prajna.pageView(otherProps);
  },
  /**
   * 信息上报
   * @param options
   */
  report(options) { // eslint-disable-line
    // const {
    //   level, name, content, ...otherProps
    // } = options;
    // prajna.report({
    //   level: level || 'INFO', // INFO|DEBUG|ERROR|WARNING
    //   name,
    //   padding: otherProps,
    //   content,
    // });
  },
  /**
   * 点击事件
   * @param options
   */
  moduleClick(options) { // eslint-disable-line
    // const { name, ...otherProps } = options;
    // LXAnalytics('moduleClick', name, { custom: otherProps }, null);
    // prajna.moduleClick(name, otherProps);
  },
  /**
   * 曝光事件
   * @param options
   */
  moduleView(options) { // eslint-disable-line
    // const { name, ...otherProps } = options;
    // LXAnalytics('moduleView', name, { custom: otherProps });
    // prajna.moduleView(name, otherProps);
  },
  /**
   * 编辑事件
   * @param options
   */
  moduleEdit(options) { // eslint-disable-line
    // const { name, ...otherProps } = options;
    // LXAnalytics('moduleEdit', name, { custom: otherProps });
    // prajna.moduleEdit(name, otherProps);
  },
};

export default record;



// WEBPACK FOOTER //
// ./src/lib/record.js